module.exports = __webpack_public_path__ + "static/media/buenos-sander-crombach.2e4ae0cb.jpg";